<template>
  <div :class="`swiper-spa-cards-${randID}`" class="swiper rhg-slider-card">
    <div class="rhg-slider-title">
      <typography v-if="title" tag="h2" size="2xl"> {{title}}</typography>
      <div class="rhg-slider-controls">
        <button :class="`swiper-spa-cards-${randID}`" class="rhg-slider-control back" >
          <Icon class="rhg-font-icon--arrow-up icon"/>
        </button>
        <button :class="`swiper-spa-cards-${randID}`" class="rhg-slider-control forward">
          <Icon class="rhg-font-icon--arrow-up icon"/>
        </button>
      </div>
    </div>
    <div class="swiper-wrapper rhg-slider-container">
      <div v-for="(slide, indx) in slides" :key="indx" class="swiper-slide">
        <CardSpa v-bind="slide.props" :numberOfCards="slides.length" :swiperInitialized="swiperInitialized" class="rhg-slider-slide" />
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../../../Atoms/Icons/Icon.vue'
import Typography from '../../../Atoms/typography/Typography.vue'
import CardSpa from '../card-spa/CardSpa.vue'
import Swiper, { Navigation } from 'swiper'
import 'swiper/swiper-bundle.css'

export default {
  name: 'SliderCard',
  props: {
    title: {
      type: String,
      required: true
    },
    slides: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      randID: Math.floor(Math.random() * 99999999),
      swiperInitialized: false
    }
  },
  components: {
    CardSpa,
    Icon,
    Typography
  },
  methods: {
    initSwiper () {
      const swiper = new Swiper('.swiper-spa-cards-' + this.randID, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        grabCursor: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2
          },
          1024: {
            slidesPerView: 3,
            slidesPerGroup: 3
          }
        },
        navigation: {
          nextEl: '.rhg-slider-control.swiper-spa-cards-' + this.randID + '.forward',
          prevEl: '.rhg-slider-control.swiper-spa-cards-' + this.randID + '.back'
        },
        modules: [Navigation]
      })
      if (swiper) {
        this.swiperInitialized = true
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      const isRTL = document.documentElement.getAttribute('dir') === 'rtl'
      const buttonSelector = isRTL
        ? '.rhg-slider-control.swiper-spa-cards-' + this.randID + '.back'
        : '.rhg-slider-control.swiper-spa-cards-' + this.randID + '.forward'
      const button = document.querySelector(buttonSelector)
      if (button) {
        button.removeAttribute('disabled')
        button.classList.remove('swiper-button-disabled')
      }
    })
    this.initSwiper()
  }
}
</script>

<style lang="scss">
@import "../../../Common/Colors.scss";
@import "./SliderCore.scss";

.rhg-spa-cards-auto-grid {
  & .rhg-slider-card {
    display: flex;
    flex-direction: column;
    gap: 26px;
  }

  .rhg-slider-title{
    padding: 0px;
  }

  & .rhg-slider-title .rhg-slider-controls{
    justify-content: end;
    max-width: fit-content;
    padding: 0px 0px 24px 0;
  }
  .rhg-slider-slide {
    .rhg-spa-card-four-hours-mobile {
      @media (min-width:992px){
        display: flex!important;
        background-color: white;
        border-top: unset;
        border-radius: 0 0 0.68rem 0.68rem;
      }
    }
    .rhg-spa-card-four-hours-desktop{
      display: none;
    }
  }
}
html[dir="rtl"] .rhg-spa-cards-auto-grid{
  & .rhg-slider-title .rhg-slider-controls{
    padding: 0;
  }
}
</style>
